import { PaymentResultType } from "./types/PaymentResultType";
import React from "react";
import { Box, Typography } from "@material-ui/core";
import Text from "../../../../../shared/components/Text";
import MainButton from "../../../../../shared/components/MainButton";
import { usePaymentResult } from "./hooks/usePaymentResult";
import { QuotaSummary } from "../PaymentPlanLine/components/shared/QuotaSummary";
import { usePaymentPlan } from "../PaymentPlan/hooks/usePaymentPlan";
import {
  PaymentPlanLineResultMessage,
  resultMessageVariantType,
} from "../PaymentPlanLine/components/shared/PaymentPlanLineResultMessage";

export const PaymentResult = ({ paymentPlanLineId, result }) => {
  const { navigateToPaymentPlanLineView } = usePaymentResult(paymentPlanLineId);
  const { paymentPlan, currentPaymentPlanLine } =
    usePaymentPlan(paymentPlanLineId);
  const values = ValuesByPaymentResult[result];

  return (
    <>
      <Box
        flexGrow={1}
        className={"appear-anim"}
        position={"relative"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Box my={3}>
          <Typography variant={"h5"} color={"textPrimary"}>
            <Text strong tId={values.titleTextId} />
          </Typography>
        </Box>
        <Box pt={1} width={"100%"}>
          <QuotaSummary
            paymentPlan={paymentPlan}
            paymentPlanLine={currentPaymentPlanLine}
          />
        </Box>
      </Box>
      <Box mb={4}>
        <PaymentPlanLineResultMessage
          paymentPlanLine={currentPaymentPlanLine}
          resultMessageVariant={resultMessageVariantType.FLYWIRE}
        />
      </Box>
      {values.btnTextId && (
        <MainButton onClick={() => navigateToPaymentPlanLineView()}>
          <Text tId={values.btnTextId} />
        </MainButton>
      )}
    </>
  );
};

const ValuesByPaymentResult = {
  [PaymentResultType.SUCCESS]: {
    titleTextId: "PAYMENT_RESULT_SUCCESS_TITLE",
    textId: "PAYMENT_RESULT_SUCCESS_TEXT",
  },
  [PaymentResultType.PROCESSING]: {
    titleTextId: "PAYMENT_RESULT_PROCESSING_TITLE",
    textId: "PAYMENT_RESULT_PROCESSING_TEXT",
  },
  [PaymentResultType.ERROR]: {
    titleTextId: "PAYMENT_RESULT_ERROR_TITLE",
    textId: "PAYMENT_RESULT_ERROR_TEXT",
    btnTextId: "RETRY",
  },
};
